import { LONG_TERM_RESERVATION_KINDS, longTermReservationKind } from "~/constants/long_term_reservation_kinds"
import { GROUP_PAYMENT_TYPES } from "~/constants/group_payment_types"

enum CreateReservationSteps {
  reservationInfo,
  paymentInfo,
}

const COOKIE_SENDING_MODE_NEW_RESERVATION = "reservation-reservation-sending-mode"

const reservationRecuringKindOptions = [
  { label: "Rent + electric", value: LONG_TERM_RESERVATION_KINDS.RENT_AND_UTILITIES },
  { label: "Rent only", value: LONG_TERM_RESERVATION_KINDS.RENT_ONLY },
  { label: "Seasonal + electric", value: LONG_TERM_RESERVATION_KINDS.UTILITIES_ONLY },
  { label: "Seasonal", value: LONG_TERM_RESERVATION_KINDS.SEASONAL_ONLY },
]

const groupOptions = [
  {
    label: "Pay separately",
    value: GROUP_PAYMENT_TYPES.SEPARATE,
  },
  {
    label: "Pay all together",
    value: "together",
  },
]

type ReservationOptions = {
  isPrePaid?: boolean
  withLink?: boolean
  isPayingNow?: boolean
  isGroupSeparated?: boolean
  recurringKind?: longTermReservationKind
}

export { CreateReservationSteps, COOKIE_SENDING_MODE_NEW_RESERVATION, reservationRecuringKindOptions, groupOptions }

export type { ReservationOptions }
